/**
 * SmbSyncPage - Main page wrapper for SMB Vendor Cost Import
 *
 * Provides page layout, title, and description
 */

import { Card, Typography } from 'antd'
import { SmbSyncWizard } from './SmbSyncWizard'

const { Title, Paragraph } = Typography

/**
 * SMB Vendor Cost Import page
 */
export default function SmbSyncPage() {
  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Page Header */}
      <Card
        style={{
          marginBottom: '24px',
          background: 'linear-gradient(135deg, #1890ff 0%, #0e7ae0 100%)',
          border: 'none',
        }}
      >
        <Title level={2} style={{ color: 'white', marginBottom: '8px' }}>
          SMB Vendor Cost Import
        </Title>
        <Paragraph style={{ color: 'rgba(255,255,255,0.9)', marginBottom: 0, fontSize: '16px' }}>
          Update your Square or QuickBooks catalog with vendor costs and recalculate prices.
          Upload your catalog, upload vendor cost file, map fields, configure pricing rules, and
          download updated files.
        </Paragraph>
      </Card>

      {/* Wizard */}
      <SmbSyncWizard />
    </div>
  )
}
